import { render, staticRenderFns } from "./card-list.vue?vue&type=template&id=968862f8&scoped=true&"
import script from "./card-list.vue?vue&type=script&lang=js&"
export * from "./card-list.vue?vue&type=script&lang=js&"
import style0 from "./card-list.vue?vue&type=style&index=0&id=968862f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968862f8",
  null
  
)

export default component.exports